// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PCarryOutOutlinedSvg from "@fishx/icons-svg/es/asn/PCarryOutOutlined";
import FishxIcon from '../components/FishxIcon';

var PCarryOutOutlined = function PCarryOutOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PCarryOutOutlinedSvg
  }));
};

PCarryOutOutlined.displayName = 'PCarryOutOutlined';
export default React.forwardRef(PCarryOutOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PCarryOutOutlined.js
// module id = 3278
// module chunks = 0